module.exports = __webpack_public_path__ + "img/digital-wallet-icon-made-currency-260nw-1734412019.0306d9b6.jpg";